export default {
  state: {
    hereMaps: {
      map: {},
      platform: {},
      router: {},
      geocoder: {},
      directions: [],
      ui: {}
    }
  },
  mutations: {
    setHereMapData (state, data) {
      for (let field in data) {
        state.hereMaps[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/runs/here-maps.js